module.exports = __webpack_public_path__ + "img/lx_btn.652e261c.png";